import type { ReactNode } from "react";

import { BackLink } from "./BackLink";

type Props = {
  title: string;
  lead?: string;
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
};

export function PageHeader({ title, lead, backTo, backLabel, actions }: Props) {
  return (
    <header className="dn-page-header">
      {backTo ? <BackLink fallbackTo={backTo} label={backLabel} /> : null}
      <div className="dn-page-header-row">
        <div className="dn-page-header-text">
          <h1>{title}</h1>
          {lead ? <p className="dn-page-lead">{lead}</p> : null}
        </div>
        {actions ? <div className="dn-page-header-actions">{actions}</div> : null}
      </div>
    </header>
  );
}
